import React from 'react';
import { LegalLinks } from './LegalLinks';

export const Footer: React.FC = () => (
    <footer className="p-2 mt-2 mt-sm-0 p-sm-4 align-self-end">
        <LegalLinks />
    </footer>
);
